import { Component, DoCheck, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { WfSignature, WfSignatureResource } from 'src/app/components/workflow/workflow';
import { RsfMainSBaseComponent } from '../rsf-main-s-base/rsf-main-s-base.component';
import { RSFButtonAction } from '../../rsf';
import { FormStatusEnum, Roles, Tag } from 'src/app/common/enumerations/enumerations';
import { RSFConfiguration } from '../../rsf.service';
import { TextareaDialogComponent } from 'src/app/controls/textarea-dialog/textarea-dialog.component';


@Component({
  selector: 'rsf-main-buttons',
  templateUrl: './rsf-main-buttons.component.html',
  styleUrls: ['./rsf-main-buttons.component.scss']
})
export class RsfMainButtonsComponent extends RsfMainSBaseComponent implements OnChanges, DoCheck {

  @Input() formValid?: boolean;
  @Input() amendmentChangesSaved?: boolean;
  // Submit Amendment is only enabled when Section 1 or hold points differ from the approved RSF.
  @Input() amendmentHasChanges?: boolean;
  @Output() buttonAction = new EventEmitter<{ action: RSFButtonAction, data?: any; }>();

  action = RSFButtonAction;

  disapproveSignature?: WfSignature | null;
  disapproveAmendmentSignature?: WfSignature | null;

  oicDisapproveEnabled?: boolean;

  unsubmitEnabled?: boolean | null;
  unsubmitAmendmentEnabled?: boolean | null;

  cancelAmendmentEnabled?: boolean | null;
  formDirty = false;

  override ngOnChanges(changes: SimpleChanges): void {
    this.resetButtons();
    this.getValues();
  }

  /**
   * Captures the shared dirty-state value before the template reads it.
   */
  ngDoCheck(): void {
    // Keep button visibility stable during Angular's dev-mode double check.
    this.formDirty = this.isFormDirty();
  }

  getValues() {
    // RSF
    const submitSignature = this.getSignature(Tag.SUBMIT);
    this.disapproveSignature = submitSignature?.disapproveActionId ? submitSignature : null;

    const workApprovalsSigned = this.rsf?.wfTable?.wfTableLocal
      ?.wfSectionLocals.find(x =>
        x.number == RSFConfiguration.ApprovalsSectionNumber)
      ?.wfSignatures?.some(x => x.signed);

    this.unsubmitEnabled = this.privileges?.canUnsubmit && !workApprovalsSigned && this.rsf?.status == FormStatusEnum.WorkApprovals && !!this.disapproveSignature;

    const oicDisapprove = !this.unsubmitEnabled && !!this.disapproveSignature && this.hasRoles([Roles.OIC]) && [FormStatusEnum.WorkApprovals, FormStatusEnum.PendingRequesterConcurrence, FormStatusEnum.PendingSafetyControls].includes(this.rsf?.status ?? 0) && !this.isAmendment();
    this.oicDisapproveEnabled = oicDisapprove;

    // RSFAmendment

    if (this.isAmendment()) {
      const submitAmendmentSignature = this.getSignature(Tag.SUBMIT_AMENDMENT);
      this.disapproveAmendmentSignature = submitAmendmentSignature?.disapproveActionId ? submitAmendmentSignature : null;

      const workApprovalsAmendmentSigned = this.rsf?.wfTable?.wfTableLocal
        ?.wfSectionLocals.find(x =>
          x.number == RSFConfiguration.AmendmentApprovalsSectionNumber)
        ?.wfSignatures?.some(x => x.signed && x.wfAmendmentID == this.rsfAmendment?.wfAmendmentID);

      this.unsubmitAmendmentEnabled =
        this.privileges?.canUnsubmitAmendment && !workApprovalsAmendmentSigned && this.rsf?.status == FormStatusEnum.AmendmentReviewApprovals && !!this.disapproveAmendmentSignature && this.status?.isViewingAmendment;

      this.cancelAmendmentEnabled = this.privileges?.canCancelAmendment && this.status?.isViewingAmendment && this.rsf?.status == FormStatusEnum.AmendmentDrafting;

      this.oicDisapproveEnabled = !this.unsubmitAmendmentEnabled && !!this.disapproveAmendmentSignature && this.hasRoles([Roles.OIC]) && [FormStatusEnum.AmendmentReviewApprovals, FormStatusEnum.AmendmentPendingRequesterConcurrence, FormStatusEnum.AmendmentPendingSafetyControls].includes(this.rsf?.status ?? 0);
    }
  }

  resetButtons() {
    this.disapproveSignature = null;
    this.unsubmitEnabled = false;
    this.oicDisapproveEnabled = false;

    this.disapproveAmendmentSignature = null;
    this.unsubmitAmendmentEnabled = false;
    this.cancelAmendmentEnabled = false;
  }

  oicDisapprove() {
    const confirm = this.dialog.open(TextareaDialogComponent, {
      width: '400px',
      data: {
        label: this.getMessage('disapprove_message')?.description,
        placeholder: 'Disapproval Reason',
        text: ''
      }
    });
    confirm.afterClosed().subscribe((data) => {
      if (data?.acceptClicked) {
        data.oicDisapprove = true;
        this.buttonAction.emit(
          { action: this.isAmendment() ? RSFButtonAction.DisapproveAmendment : RSFButtonAction.Disapprove, data }
        );
      }
    });


  }

}
